import { ReactNode } from "react";
import CookieBannerComponent from "../ui/cookie.banner.component";
import { FooterComponent } from "./footer.component";
import { HeaderComponent } from "./header.component";

interface PageLayoutProps {
  children: ReactNode;
}

function PageLayoutComponent({ children }: PageLayoutProps) {
  return (
    <>
      <HeaderComponent />
      {children}
      <CookieBannerComponent/>
      <FooterComponent /> 
    </>
  );
}

export default PageLayoutComponent;